// `fits` uses actual browser layout; this module owns lossless token boundaries.
export function paginateMeasured(tokens, ranges, fits) {
  const pages = [];
  for (const [sentenceIndex, range] of ranges.entries()) {
    const sectionStart = pages.length;
    let cursor = range.start;
    let remaining = null;
    while (cursor < range.end) {
      const first = remaining || tokens[cursor];
      const candidates = end => [first, ...tokens.slice(cursor + 1, end)];
      let low = cursor, high = cursor + 1;
      // Exponential bounds avoid cloning the whole book for every page.
      while (high <= range.end && fits(candidates(high))) {
        low = high;
        if (high === range.end) break;
        high = Math.min(range.end, cursor + (high - cursor) * 2);
      }
      while (low + 1 < high) {
        const middle = Math.floor((low + high) / 2);
        if (fits(candidates(middle))) low = middle;
        else high = middle;
      }
      if (low > cursor) {
        pages.push({ tokens: candidates(low), sentenceIndex });
        cursor = low;
        remaining = null;
      } else {
        // A single long word can exceed a small screen. Continue it on the
        // next page without losing its original identity or splitting marks.
        const text = first._readerText || '';
        const chunks = typeof Intl.Segmenter === 'function'
          ? [...new Intl.Segmenter(undefined, { granularity: 'grapheme' }).segment(text)].map(s => s.segment)
          : Array.from(text);
        let a = 0, b = chunks.length;
        while (a < b) {
          const middle = Math.ceil((a + b) / 2);
          if (fits([{ ...first, _readerText: chunks.slice(0, middle).join('') }])) a = middle;
          else b = middle - 1;
        }
        if (!a) return { pages: [], insufficientSpace: true };
        const prefix = chunks.slice(0, a).join('');
        pages.push({ tokens: [{ ...first, _readerText: prefix }], sentenceIndex });
        const rest = text.slice(prefix.length);
        remaining = rest ? { ...first, _readerText: rest, _readerOffset: (first._readerOffset || 0) + prefix.length } : null;
        if (!remaining) cursor += 1;
      }
    }
    const parts = pages.length - sectionStart;
    for (let i = sectionStart; i < pages.length; i++) {
      pages[i].part = i - sectionStart;
      pages[i].parts = parts;
    }
  }
  return { pages, insufficientSpace: false };
}

export function pageContaining(pages, index, offset = 0) {
  const page = pages.findIndex(page => page.tokens.some(token => token._readerIndex === index && (token._readerOffset || 0) <= offset && (token._readerOffset || 0) + (token._readerText?.length || 1) > offset));
  return page < 0 ? Math.max(0, pages.length - 1) : page;
}